import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.02 1.973A5.4 5.4 0 0 0 10 1.042c-1.505 0-2.94.638-3.991 1.76C4.959 3.921 4.375 5.431 4.375 7c0 3.025-.607 4.926-1.181 6.049-.288.563-.57.936-.77 1.161a3 3 0 0 1-.285.28l-.007.005a.625.625 0 0 0 .368 1.13h15a.625.625 0 0 0 .368-1.13l-.007-.006-.053-.045a3 3 0 0 1-.231-.234 5.6 5.6 0 0 1-.77-1.161c-.367-.716-.746-1.748-.973-3.186a5 5 0 0 1-1.333-.531c.22 1.93.697 3.317 1.193 4.286q.224.433.44.757H3.866a8 8 0 0 0 .44-.757c.677-1.322 1.32-3.421 1.32-6.618 0-1.261.47-2.463 1.295-3.344.825-.879 1.933-1.364 3.08-1.364.852 0 1.683.268 2.391.766q.249-.586.63-1.085M8.245 16.96a.625.625 0 0 1 .854.227 1.04 1.04 0 0 0 1.802 0 .625.625 0 1 1 1.081.628 2.29 2.29 0 0 1-3.964 0 .625.625 0 0 1 .227-.855",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.958 1.834c.345 0 .625.28.625.624v1.875h1.875a.625.625 0 1 1 0 1.25h-1.875v1.875a.625.625 0 1 1-1.25 0V5.584h-1.875a.625.625 0 1 1 0-1.25h1.875V2.459c0-.345.28-.625.625-.625",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }